export default "__VITE_ASSET__CyohHA8N__"